import { useSearchParams } from 'react-router-dom';
import useSettings from './useSettings';

//todo: change the name and/or terms for this hook depending on who can create an insight and score events
// once a new lyaout will be designed for these views - anyone with these permissions will be able to view them
const useIsGQInternalUser = () => {
    const [searchParams] = useSearchParams();
    if (searchParams.has('force_external_user')) {
        return false;
    }
    const { settings, loading: loadingSettings } = useSettings();
    if (loadingSettings) {
        return false;
    }
    const uscoreRes = settings?.permissions?.uscoreResource;
    if (!uscoreRes) {
        return false;
    }
    //todo: merge with eventUtils.ts (but remove the Event param first)
    return (
        uscoreRes.canEdit ||
        uscoreRes.canScore ||
        uscoreRes.canDelete
    );
};

export default useIsGQInternalUser;
